import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { relationshipModel } from '~/models';
import { useCobStorage } from '../../CobStorageContext';
export const OptionalServicesContext = createContext(undefined);
export function useOptionalServicesSelection() {
    const context = useContext(OptionalServicesContext);
    if (!context) {
        throw new Error('useOptionalServicesSelection must be used within an OptionalServicesProvider');
    }
    return context;
}
export const useOptionalServicesState = (param)=>{
    let { relationship, selectedBundleId } = param;
    const { getFromStorage, setToStorage } = useCobStorage(relationship);
    const [selectedOptionalServices, setSelectedOptionalServices] = useState(()=>{
        const stored = getFromStorage('selected_optional_services');
        if (stored) return stored;
        return relationshipModel.includedByDefaultOptionalServices(relationship, selectedBundleId);
    });
    const toggleOptionalService = useCallback((serviceId)=>{
        setSelectedOptionalServices((prev)=>{
            const newSelected = prev.includes(serviceId) ? prev.filter((id)=>id !== serviceId) : [
                ...prev,
                serviceId
            ];
            setToStorage('selected_optional_services', newSelected);
            return newSelected;
        });
    }, [
        setToStorage
    ]);
    const isServiceSelected = useCallback((serviceId)=>selectedOptionalServices.includes(serviceId), [
        selectedOptionalServices
    ]);
    const optionalServicesContextValue = useMemo(()=>({
            selectedOptionalServices,
            toggleOptionalService,
            isServiceSelected
        }), [
        selectedOptionalServices,
        toggleOptionalService,
        isServiceSelected
    ]);
    return {
        selectedOptionalServices,
        optionalServicesContextValue
    };
};
